import type { ThemePrimaryStyle, ThemeTokens } from "@/contracts/types";

export function applyTheme(
  tokens: ThemeTokens,
  opts?: { primaryStyle?: ThemePrimaryStyle },
) {
  const root = document.documentElement;

  // 1) Write canonical Framixor vars ONLY (fx-*)
  root.style.setProperty("--fx-bg", tokens.bg);
  root.style.setProperty("--fx-fg", tokens.fg);

  root.style.setProperty("--fx-primary", tokens.primary);
  root.style.setProperty("--fx-primaryFg", tokens.primaryFg);

  root.style.setProperty("--fx-accent", tokens.accent);
  root.style.setProperty("--fx-gold", tokens.gold);
  root.style.setProperty("--fx-muted", tokens.muted);
  root.style.setProperty("--fx-border", tokens.border);

  // 2) Primary style endpoints (keep as fx extension vars)
  const style: ThemePrimaryStyle = opts?.primaryStyle ?? "solid";
  root.setAttribute("data-fx-primary-style", style);

  const from = tokens.primaryFrom ?? tokens.primary;
  const to = tokens.primaryTo ?? tokens.primary;

  root.style.setProperty("--fx-primary-from", from);
  root.style.setProperty("--fx-primary-to", to);
}
